<template>
    <link-dialog v-model="currentValue"
                 dialog-class="link-slider-preview"
                 noHeader
                 noFooter
                 height="100%"
                 width="100%"
                 noPadding
                 shadowColor="transparent"
                 transition="link-dialog-scale"
                 destroyOnHide
                 :zIndex="9999"
                 full>
        <div class="link-slider-preview-content">
            <link-slider :page-index.snyc="pageIndex" :loop="false" :auto-play="false" :no-dot="false" ref="linkSlider"
                         @dblclick.native="modalClose">
                <div v-for="(item,index) in filterPicData" :key="index" class="link-slider-preview-center">
                    <img :src="!!picKey ? item[picKey] : item">
                    <div v-for="(item,index) in filterPicInfo" :key="index" class="img-info">
                        {{(!!item && !!picKey) ? item[picKey] : item}}
                    </div>
                </div>
            </link-slider>
            <div class="link-slider-preview-icon link-slider-preview-icon-left" v-show="filterPicData.length !== 1"
                 @click="pagePrev">
                <link-icon icon="link-icon-left"/>
            </div>
            <div class="link-slider-preview-icon link-slider-preview-icon-right" v-show="filterPicData.length !== 1"
                 @click="pageNext">
                <link-icon icon="link-icon-right"/>
            </div>
            <div class="link-slider-preview-icon link-slider-preview-link-close" @click="modalClose">
                <link-icon icon="link-icon-close"/>
            </div>
        </div>
    </link-dialog>
</template>

<script>

    /**
     * 页面：official-website-detail 在用这个组件，不能删除
     * @author  韦胜健
     * @date    2019/12/9 20:45
     */

    export default {
        name: "link-slider-preview",
        props: {
            value: {},                                      // 控制model的显示于隐藏
            picData: {},                                    // 传入组件的图片信息
            picInfo: {},                                    // 传入组件的图片描述信息
            picKey: {type: String},                         // 当picData是对象数组时，来标识图片路径的key值
            pageIndex: {type: Number, default: 0}           // 组件从第几张开始
        },
        data() {
            return {
                currentValue: this.value
            }
        },
        watch: {
            value(val) {
                if (this.currentValue !== val) this.currentValue = val;
            },
            currentValue(val) {
                this.$emit('input', val);
            },
        },
        computed: {
            // 计算属性，判断接收的数据时对象还是数组
            filterPicData() {
                return Array.isArray(this.picData) ? this.picData : [this.picData];
            },
            // 计算属性，判断接收的数据时对象还是数组
            filterPicInfo() {
                return Array.isArray(this.picInfo) ? this.picInfo : [this.picInfo];
            }
        },
        methods: {
            /**
             * 预览上一张图片
             * @createdby：WangYue
             * @date：2018/12/18
             */
            pagePrev() {
                let dom = this.$refs.linkSlider;
                dom.gotoPrev();
            },
            /**
             * 预览下一张图片
             * @createdby：WangYue
             * @date：2018/12/18
             */
            pageNext() {
                let dom = this.$refs.linkSlider;
                dom.gotoNext();
            },
            /**
             * 关闭预览
             * @createdby：WangYue
             * @date：2018/12/18
             */
            modalClose() {
                this.currentValue = false;
            }
        }
    }
</script>

<style lang="scss">
    .link-slider-preview {
        .link-dialog-content {
            background-color: transparent !important;
            position: relative;

            .link-slider-preview-content {
                height: 100%;

                .link-slider-wrpper {
                    height: 100%;

                    .link-slider-group {
                        height: 100%;

                        .link-slider-preview-center {
                            height: 100%;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            background-color: rgba(0, 0, 0, 0.65);

                            img {
                                max-width: 80%;
                            }

                            .img-info {
                                font-family: PingFangTC-Semibold;
                                color: white;
                                position: absolute;
                                bottom: 7%;
                                font-size: 1.5rem;
                                line-height: 3rem;
                            }
                        }
                    }
                }
            }

            .link-slider-preview-icon {
                font-size: 42px;
                color: rgba(255, 255, 255, 0.75);
                cursor: pointer;
                position: absolute;
            }

            .link-slider-preview-icon-left {
                top: 50%;
                left: 24px;
            }

            .link-slider-preview-icon-right {
                top: 50%;
                right: 24px;
            }

            .link-slider-preview-link-close {
                font-size: 24px;
                top: 24px;
                right: 24px;
            }
        }
    }
</style>
